(() => {
  const page = document.querySelector(".PPAInfoPage"),
    prose = page?.querySelector("[data-ppa-prose]"),
    nav = page?.querySelector(".PPAInfoContents nav");
  if (!prose || !nav) return;
  const headings = [...prose.querySelectorAll("h2,h3")];
  if (!headings.length) return;
  headings.forEach((h, i) => {
    if (!h.id) h.id = "guide-" + (i + 1);
    const a = document.createElement("a");
    a.href = "#" + h.id;
    a.textContent = h.textContent;
    nav.appendChild(a);
  });
  page.querySelector(".PPAInfoContents").hidden = false;
})();
